import type { ChangelogEntry } from "../types";

/** VIB-3050 PR 3c: «er booker» som egen innstilling, listeeiere fases ut. */
export const LEADS_BOOKERE_2026_11: ChangelogEntry = {
  id: "2026-11-04-leads-bookere",
  date: "2026-11-04",
  title: "Leadlister: legg til og fjern bookere",
  summary:
    "Hvem som ringer leads, settes nå under «Bookere» i Leadlister, ikke ved å gi dem en liste. Køene fylles bare fra felles pooler.",
  sections: [
    {
      heading: "Leadlister",
      items: [
        {
          title: "Legg til booker",
          kind: "nytt",
          body: "Velg en ansatt under «Bookere», så får hen Leads uten å bytte rolle. «Fjern som booker» i kortet tar det bort igjen, og leadene i køen går tilbake til poolen.",
          minRole: "admin",
        },
        {
          title: "Lister har ikke lenger eier",
          kind: "forbedret",
          body: "Eier-kolonnen er borte fra listetabellen. Køen fylles fra felles pooler, og leadene fra arket ligger i poolen «Arket».",
          minRole: "admin",
        },
      ],
    },
  ],
};
